import tw, { styled } from 'twin.macro';

export const HorizontalPadding = styled.div`
  ${tw`pl-2 pr-2 sm:pl-3 sm:pr-3 md:pl-8 md:pr-8 lg:pl-16 lg:pr-16 `};
`;

export const VerticalPadding = tw.div`
  pt-3 pb-3 sm:pt-3 sm:pb-3 md:pt-6 md:pb-6 lg:pt-6 lg:pb-6
`;
